module.exports = __webpack_public_path__ + "static/media/im.8b2a8fa9.mp3";